import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TrainIcon(props: IconProps) {
    return <Icon {...props} iconKey={"train"}/>
}
